<template>
  <div class="ep-container">
    <div class="content-div">
      <!-- 修改返回按钮部分 -->
      <div class="ep-nav">
        <div class="ep-nav-left">
          <button class="ep-back-button" @click="handleBack">
            <svg t="1747387769340" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="4602" width="200" height="200">
              <path
                d="M374.2208 515.9424L774.912 115.2512a56.448 56.448 0 1 0-79.8464-79.8464L255.8976 474.5984c-22.016 22.016-22.016 57.7792 0 79.8208 1.7408 1.7408 3.712 3.1232 5.632 4.608 0.3072 0.3328 0.5632 0.768 0.896 1.1008l428.8768 428.8768a55.1168 55.1168 0 1 0 77.952-77.952L374.2208 515.9424z"
                fill="#F8B62D" p-id="4603"></path>
            </svg> <span>返回</span>
          </button>
        </div>
        <div class="ep-nav-right">
          <button class="ep-fullscreen-button" @click="printQuestions">
            <svg t="1747839081798" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="5868" width="200" height="200">
              <path
                d="M146.285714 243.809524v633.904762a97.52381 97.52381 0 0 0 97.52381 97.523809h-24.380953A146.285714 146.285714 0 0 1 73.142857 828.952381V219.428571A146.285714 146.285714 0 0 1 219.428571 73.142857h707.047619v73.142857H243.809524a97.52381 97.52381 0 0 0-97.52381 97.52381z"
                fill="#F8B62D" opacity=".1" p-id="5869"></path>
              <path
                d="M853.333333 999.619048H170.666667A146.285714 146.285714 0 0 1 24.380952 853.333333V170.666667A146.285714 146.285714 0 0 1 170.666667 24.380952h682.666666a146.285714 146.285714 0 0 1 146.285715 146.285715v682.666666a146.285714 146.285714 0 0 1-146.285715 146.285715z m73.142857-804.571429a97.52381 97.52381 0 0 0-97.523809-97.523809H195.047619a97.52381 97.52381 0 0 0-97.523809 97.523809v633.904762a97.52381 97.52381 0 0 0 97.523809 97.523809h633.904762a97.52381 97.52381 0 0 0 97.523809-97.523809V195.047619z"
                fill="#F8B62D" p-id="5870"></path>
              <path
                d="M707.047619 828.952381H585.142857a36.571429 36.571429 0 0 1 0-73.142857h97.52381a73.142857 73.142857 0 0 0 19.382857-2.913524l-123.12381-123.12381a35.961905 35.961905 0 0 1 50.834286-50.870857l123.12381 123.12381A72.521143 72.521143 0 0 0 755.809524 682.666667v-97.52381a36.571429 36.571429 0 0 1 73.142857 0v121.904762a121.904762 121.904762 0 0 1-121.904762 121.904762zM438.857143 268.190476h-97.52381a73.142857 73.142857 0 0 0-19.382857 2.913524l123.12381 123.12381a35.961905 35.961905 0 0 1-50.834286 50.870857l-123.12381-123.12381A72.43581 72.43581 0 0 0 268.190476 341.333333v97.52381a36.571429 36.571429 0 0 1-73.142857 0V316.952381a121.904762 121.904762 0 0 1 121.904762-121.904762h121.904762a36.571429 36.571429 0 0 1 0 73.142857z"
                fill="#F8B62D" p-id="5871"></path>
            </svg>
          </button>
        </div>
      </div>
      <!-- 修改页面头部 -->
      <div class="ep-header" v-if="!loading">
        <h1 class="ep-title">{{ paperTitle }}</h1>
        <div class="ep-meta">
          <span class="ep-course">{{ courseName }}</span>
          <span class="ep-time">{{ paperTime }}</span>
        </div>
      </div>

      <!-- 加载状态显示 -->
      <div v-if="loading" class="ep-loading">
        <LoaderCom />
        <p>正在加载试卷数据...</p>
      </div>

      <!-- 错误状态显示 -->
      <div v-else-if="error" class="ep-error">
        <p>{{ error }}</p>
        <button @click="fetchPaperData" class="ep-retry-btn">重试</button>
      </div>

      <!-- 试卷内容 -->
      <div v-else class="paper-content">

        <!-- 在 questions-container 中的 question-item 部分添加材料题支持 -->
        <div class="questions-container">
          <div v-for="(question, index) in questions" :key="index" class="ep-question">
            <div class="ep-question-header">
              <h3 class="ep-question-title">第 {{ index + 1 }} 题（{{ question.score }}分）</h3>
              <span class="ep-question-type">{{ question.type }}</span>
            </div>
            <div class="ep-question-content">
              <p v-html="question.content"></p>

              <!-- 材料题附件 -->
              <div v-if="question.type === '材料题' && question.fileUrl" class="ep-material">
                <div class="ep-material-preview">
                  <img v-if="isImageFile(question.fileName)" :src="question.fileUrl" alt="材料图片"
                    class="ep-material-image">
                  <div v-else class="file-icon">
                    <i class="file-icon-placeholder">📄</i>
                  </div>
                </div>
                <div class="ep-material-info">
                  <p class="ep-material-name">{{ question.fileName }}</p>
                  <a :href="question.fileUrl" target="_blank" class="ep-download-btn">查看原图</a>
                  <a :href="question.fileUrl" download :filename="question.fileName" class="ep-download-btn">下载附件</a>
                </div>
              </div>

              <!-- 单选题选项 -->
              <div v-if="question.type === '单选题'" class="ep-options">
                <div v-for="(option, optIndex) in question.options" :key="optIndex" class="ep-option"
                  :class="{ 'ep-option-correct': option.value === question.rightAnswer }">
                  <div class="ep-option-label">
                    <div class="ep-option-text">{{ option.label }}.</div>
                    <div class="ep-option-content" v-html="option.text"></div>
                  </div>
                </div>
              </div>

              <!-- 多选题选项 -->
              <div v-else-if="question.type === '多选题'" class="ep-options">
                <div v-for="(option, optIndex) in question.options" :key="optIndex" class="ep-option"
                  :class="{ 'ep-option-correct': question.rightAnswer && question.rightAnswer.includes(option.value) }">
                  <div class="ep-option-label">
                    <div class="ep-option-text">{{ option.label }}.</div>
                    <div class="ep-option-content" v-html="option.text"></div>
                  </div>
                </div>
              </div>

              <!-- 判断题选项 -->
              <div v-else-if="question.type === '判断题'" class="ep-options">
                <div class="ep-option" :class="{ 'ep-option-correct': question.rightAnswer === 'yes' }">
                  <div class="ep-option-label">
                    <span class="ep-option-text">正确</span>
                  </div>
                </div>
                <div class="ep-option" :class="{ 'ep-option-correct': question.rightAnswer === 'no' }">
                  <div class="ep-option-label">
                    <span class="ep-option-text">错误</span>
                  </div>
                </div>
              </div>

              <!-- 填空题 -->
              <div v-else-if="question.type === '填空题'" class="ep-blank-answer">
                <div v-if="question.rightAnswer" class="ep-answer">
                  <p class="ep-answer-label">正确答案：</p>
                  <template v-if="isValidJson(question.rightAnswer) || /<img[^>]+>/.test(question.rightAnswer)">
                    <div v-for="(blank, blankIndex) in parseAnswer(question.rightAnswer)" :key="blankIndex"
                      class="ep-answer-content">
                      <template v-if="blank.length > 1">
                        <p>第{{ blankIndex + 1 }}空：</p>
                        <div v-for="(answer, answerIndex) in blank" :key="answerIndex">
                          <span v-html="answer"></span>
                          <span v-if="answerIndex < blank.length - 1"> 或 </span>
                        </div>
                      </template>
                      <template v-else>
                        <p v-if="parseAnswer(question.rightAnswer).length > 1">第{{ blankIndex + 1 }}空：</p>
                        <span v-html="blank[0]"></span>
                      </template>
                    </div>
                  </template>
                  <div v-else class="ep-answer-content">
                    <span v-html="question.rightAnswer"></span>
                  </div>
                </div>
                <div v-else class="ep-answer">
                  <p class="ep-answer-label">正确答案：</p>
                  <p class="ep-answer-content">暂无答案</p>
                </div>
              </div>
              <div v-else class="ep-answer">
                <p class="ep-answer-label">正确答案：</p>
                <p class="ep-answer-content">暂无答案</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!loading" class="ep-footer">
        <button class="ep-submit-btn" @click="handleBack">返回列表</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import apiConfig from '../config/api.js';
import LoaderCom from '../components/LoaderCom.vue';
import { printQuestions } from '../custom.js';  // 已经正确导入

export default {
  components: {
    LoaderCom
  },
  data() {
    return {
      paperTitle: '',
      courseName: '',
      paperTime: '',
      questions: [],
      resourceId: null,
      paperData: null, // 存储完整的试卷数据
      loading: true,
      error: null,
      totalScore: 100,
      examDuration: 120,
      fromDashboard: false, // 添加标记，表示是否从 Dashboard 页面进入
    };
  },
  created() {
    // 从路由参数获取试卷信息
    const { id, title, course, fromDashboard } = this.$route.params;
    console.log
    console.log('试卷页面创建，路由参数:', this.$route.params);
    this.resourceId = id;
    this.paperTitle = title || '未命名试卷';
    this.courseName = course || '未知课程';
    this.paperTime = new Date().toLocaleDateString();

    // 恢复滚动功能
    document.body.classList.remove('course-expanded');
    document.body.style.overflow = 'auto';
    document.documentElement.style.overflow = 'auto';

    if (fromDashboard === 'true') {
      this.fromDashboard = true;
    }
    console.log('fromDashboard:', fromDashboard);
    // 无论如何都尝试获取数据
    this.fetchPaperData();
  },

  methods: {
    // 检查是否为有效的JSON
    isValidJson(str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
    async fetchPaperData() {
      try {
        this.loading = true;
        console.log('正在获取试卷数据，ID:', this.resourceId);

        // 检查本地缓存
        const cacheKey = `paper_data_${this.resourceId}`;
        const cachedData = localStorage.getItem(cacheKey);

        if (cachedData) {
          const { data, timestamp } = JSON.parse(cachedData);
          const now = new Date().getTime();
          // 检查缓存是否有效（24小时内）
          if (now - timestamp < 24 * 60 * 60 * 1000) {
            console.log('使用本地缓存数据');
            this.paperData = data;
            // 设置试卷基本信息
            this.paperTitle = this.paperData.paperName || this.paperTitle;
            this.courseName = this.paperData.courseName || this.courseName;
            this.paperTime = this.formatTime(this.paperData.createTime) || this.paperTime;
            this.examDuration = this.paperData.duration ? Math.floor(this.paperData.duration / 60) : 120;
            // 处理题目数据
            this.processQuestions();
            this.loading = false;
            return;
          } else {
            // 清除过期缓存
            localStorage.removeItem(cacheKey);
          }
        }

        // 如果没有缓存或缓存已过期，从服务器获取数据
        const url = `${apiConfig.baseURL}${apiConfig.paperURL}?paperId=${this.resourceId || 'default'}`;
        console.log('请求URL:', url);

        const response = await axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          timeout: 20000
        });

        console.log('API响应:', response.data);

        if (response.data.success) {
          // 解析数据
          this.paperData = JSON.parse(response.data.data.data).data;

          // 缓存数据
          const cacheData = {
            data: this.paperData,
            timestamp: new Date().getTime()
          };
          localStorage.setItem(cacheKey, JSON.stringify(cacheData));

          // 设置试卷基本信息
          this.paperTitle = this.paperData.paperName || this.paperTitle;
          this.courseName = this.paperData.courseName || this.courseName;
          this.paperTime = this.formatTime(this.paperData.createTime) || this.paperTime;
          this.examDuration = this.paperData.duration ? Math.floor(this.paperData.duration / 60) : 120;

          // 处理题目数据
          this.processQuestions();
        } else {
          console.error('获取试卷数据失败:', response.data.message);
          this.error = '获取试卷数据失败: ' + (response.data.message || '未知错误');
          this.loadMockData();
        }
      } catch (error) {
        console.error('获取试卷数据错误:', error);
        this.error = '获取试卷数据错误: ' + (error.message || '如果你是浙江移动网络可以尝试更换，或者使用插件');
        this.loadMockData();
      } finally {
        this.loading = false;
      }
    },

    // 处理题目数据
    // 在 processQuestions 方法中修改题目类型判断部分
    processQuestions() {
      if (!this.paperData || !this.paperData.paperSubjectList) {
        console.error('试卷数据格式不正确');
        return;
      }

      // 计算总分
      let totalScore = 0;

      // 转换题目格式
      this.questions = this.paperData.paperSubjectList.map(subject => {
        // 确定题目类型
        let type = '未知';
        if (subject.subjectType === 1) {
          type = '单选题';
        } else if (subject.subjectType === 2) {
          type = '多选题';
        } else if (subject.subjectType === 3) {
          type = '判断题';
        } else if (subject.subjectType === 4) {
          type = '填空题';
        } else if (subject.subjectType === 5) {
          type = '完型填空';
        } else if (subject.subjectType === 7) {
          type = '填空题';  // 数学填空题
        } else if (subject.subjectType === 8) {
          type = '简答题';
        } else if (subject.subjectType === 9) {
          type = '材料题';
        }

        // 处理选项
        const options = subject.subjectOptions ? subject.subjectOptions.map(opt => ({
          label: opt.optionHead,
          value: opt.optionHead,
          text: opt.optionContent
        })) : [];

        // 处理子题目（针对材料题）
        const children = subject.childrenList ? subject.childrenList.map(child => ({
          id: child.id,
          content: child.subjectName,
          score: child.subjectScore,
          rightAnswer: child.rightAnswer,
          type: this.getSubjectTypeText(child.subjectType)
        })) : [];

        // 累加总分
        totalScore += subject.subjectScore;

        return {
          id: subject.id,
          type: type,
          content: subject.subjectName,
          score: subject.subjectScore,
          options: options,
          rightAnswer: subject.rightAnswer,
          children: children,
          fileName: subject.fileName || '',
          fileUrl: subject.fileUrl || ''
        };
      });

      this.totalScore = totalScore;
    },

    // 获取题目类型文本
    getSubjectTypeText(typeCode) {
      const typeMap = {
        1: '单选题',
        2: '多选题',
        3: '判断题',
        4: '填空题',
        5: '完型填空',
        7: '填空题',
        8: '简答题',
        9: '材料题'
      };
      return typeMap[typeCode] || '未知';
    },

    // 判断是否为图片文件
    isImageFile(fileName) {
      if (!fileName) return false;
      const imgExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
      const ext = fileName.toLowerCase().substring(fileName.lastIndexOf('.'));
      return imgExtensions.includes(ext);
    },

    // 去除HTML标签
    stripHtmlTags(html) {
      if (!html) return '';
      return html.replace(/<\/?[^>]+(>|$)/g, '');
    },

    // 格式化时间
    formatTime(timeString) {
      if (!timeString) return '';
      try {
        const date = new Date(timeString);
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      } catch (e) {
        return timeString;
      }
    },

    // 添加加载模拟数据的方法
    loadMockData() {
      console.log('加载模拟数据');
      this.questions = [
        {
          type: '单选题',
          content: '<p>中型药品企业的仓库面积不应低于 （ ）</p>',
          score: 0.5,
          options: [
            { label: 'A', value: 'A', text: '<p>500m2</p>' },
            { label: 'B', value: 'B', text: '<p>1000m2</p>' },
            { label: 'C', value: 'C', text: '<p>1500m2</p>' },
            { label: 'D', value: 'D', text: '<p>800m2</p>' }
          ],
          rightAnswer: 'B'
        },
        {
          type: '判断题',
          content: '<p>药店店员只要不得传染性就没必要去进行体检。</p>',
          score: 0.5,
          rightAnswer: 'no'
        },
        {
          type: '填空题',
          content: 'Vue实例的生命周期钩子函数中，组件挂载到DOM后调用的是_______方法。',
          score: 0.5,
          rightAnswer: 'mounted'
        }
      ];
    },

    handleBack() {
      // 在返回之前先执行截图
      console.log(this.fromDashboard)
      if (this.fromDashboard) {
        this.$router.push('/dashboard');
      } else {
        this.$router.push('/search');
      }
    },

    // 安全解析答案
    parseAnswer(answer) {
      // 如果答案包含HTML标签，直接提取内容并返回
      if (/<img[^>]+>/.test(answer)) {
        // 尝试从JSON格式中提取HTML内容
        try {
          const parsed = JSON.parse(answer);
          if (Array.isArray(parsed) && parsed.length > 0) {
            // 处理嵌套数组
            return parsed.map(item => {
              if (Array.isArray(item) && item.length > 0) {
                return item;
              }
              return [item];
            });
          }
          return [[answer]];
        } catch (e) {
          // 如果不是有效的JSON，直接返回原始内容
          return [[answer]];
        }
      }

      // 处理普通JSON格式答案
      try {
        const parsed = JSON.parse(answer);

        // 处理嵌套数组
        if (Array.isArray(parsed)) {
          return parsed.map(item => {
            if (Array.isArray(item)) {
              return item.map(subItem => String(subItem).replace(/[[\]]/g, ''));
            }
            return [String(item).replace(/[[\]]/g, '')];
          });
        }
        return [[String(parsed).replace(/[[\]]/g, '')]];
      } catch (e) {
        // 非JSON格式直接处理方括号
        return [[answer.replace(/[[\]]/g, '')]];
      }
    },

    async printQuestions() {
      try {
        await printQuestions();
      } catch (error) {
        console.error('截图失败:', error);
      }
    },
  }
};





</script>

<style scoped>
/* 整体页面布局调整 */
.ep-container {
  height: calc(100% - 70px);
  overflow: auto;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.content-div {
  max-width: 1200px;
  min-width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 返回按钮样式调整 */
.ep-nav {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.ep-nav-left,
.ep-nav-right {
  display: flex;
  align-items: center;
}

.ep-back-button {
  margin-left: 10px;
  display: flex;
  align-items: center;
  padding: 6px 12px;
  background-color: transparent;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.ep-back-button svg {
  fill: #F8B62D;
  width: 25px;
  height: 25px;
}


.ep-back-button span {
  color: #F8B62D;
  margin-left: 5px;
  font-size: 20px;
}

.ep-back-button:hover {
  background-color: #f8f8f8;
}

.ep-fullscreen-button {
  margin-right: 10px;
  display: flex;
  align-items: center;
  padding: 6px 12px;
  background-color: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.ep-fullscreen-button:hover {
  background-color: #f8f8f8;
}

.ep-fullscreen-button svg {
  width: 25px;
  height: 25px;
}

/* 页面标题部分调整 */
.ep-header {
  margin: 30px auto 20px;
  text-align: center;
  padding: 15px 0;
  border-bottom: 2px solid #f8b62d;
  max-width: 85%;
}

.ep-title {
  font-size: 24px;
  margin-bottom: 10px;
  color: #333;
  font-weight: 600;
}

.ep-meta {
  display: flex;
  justify-content: center;
  gap: 15px;
  color: #666;
  font-size: 13px;
}

.ep-course,
.ep-time {
  background-color: #f8f9fa;
  padding: 4px 12px;
  border-radius: 16px;
  color: #666;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

/* 试卷说明部分调整 */
.ep-instructions {
  background-color: #fff;
  padding: 18px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  border-left: 3px solid #f8b62d;
}

.ep-instructions h2 {
  color: #f8b62d;
  margin-bottom: 10px;
  font-size: 18px;
}

.ep-instructions p {
  font-size: 14px;
  margin: 5px 0;
}

/* 题目卡片调整 */
.ep-question {
  margin-left: 10px;
  margin-right: 10px;
  border: 1.2px solid rgb(239, 239, 239);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 18px;
  background-color: #fcfcfc;
  box-shadow: 8px 8px 20px 0 rgba(0, 0, 0, 0.02);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.ep-question:hover {
  /* transform: translateY(-2px); */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
}

/* 题目标题调整 */
.ep-question-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.ep-question-title {
  font-size: 16px;
  margin: 0;
  color: #333;
  font-weight: 600;
}

.ep-question-type {
  background-color: #f0f0f0;
  color: #666;
  padding: 3px 10px;
  border-radius: 3px;
  font-size: 13px;
  font-weight: normal;
}

/* 题目内容调整 */
.ep-question-content {
  font-size: 14px;
}

.ep-question-content p {
  margin: 8px 0;
}

/* 选项调整 */
.ep-options {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* 选项项目样式优化 */
.ep-option {
  padding: 10px 15px;
  border-radius: 8px;
  background-color: #f8f9fa;
  border: 1px solid #eee;
  transition: all 0.2s ease;
}

.ep-option:hover {
  background-color: #f0f0f0;
  border-color: #ddd;
}

/* 正确选项样式优化 */
.ep-option-correct {
  background-color: rgba(76, 175, 80, 0.1);
  border: 1px solid rgba(76, 175, 80, 0.3);
  position: relative;
  /* border-left: 3px solid #4CAF50; */
}

.ep-option-correct:hover {
  background-color: rgba(76, 175, 80, 0.15);
}

/* 选项标签样式优化 */
.ep-option-label {
  display: flex;
  align-items: center;
  /* 修改为center以实现垂直居中 */
}

/* 选项文本样式 */
.ep-option-text {
  font-weight: 500;
  margin-right: 8px;
  min-width: 20px;
  flex: 0 0 auto;
  display: flex;
  /* 添加flex布局 */
  align-items: center;
  /* 添加垂直居中 */
  height: 100%;
  /* 确保高度占满父容器 */
}

/* 选项内容样式 */
.ep-option-content {
  flex: 1;
  display: flex;
  /* 添加flex布局 */
  align-items: center;
  /* 添加垂直居中 */
  min-height: 24px;
  /* 设置最小高度确保内容较少时也能居中 */
}

.ep-option-content p {
  margin: 0;
  padding: 0;
}

/* 选项项目样式优化 - 调整内边距使垂直居中更明显 */
.ep-option {
  padding: 12px 15px;
  /* 增加垂直内边距 */
  border-radius: 8px;
  background-color: #f8f9fa;
  border: 1px solid #eee;
  transition: all 0.2s ease;
  display: flex;
  /* 添加flex布局 */
  align-items: stretch;
  /* 子元素拉伸以填充容器高度 */
}

.ep-option:hover {
  background-color: #f0f0f0;
  border-color: #ddd;
}

/* 答案区域调整 */
.ep-answer {
  margin-top: 15px;
  padding: 12px 15px;
  background-color: #f8f9fa;
  /* border-left: 3px solid #4CAF50; */
  border-radius: 6px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
}

.ep-answer-label {
  font-weight: 600;
  color: #4CAF50;
  margin-bottom: 8px;
  font-size: 14px;
}

.ep-answer-content {
  font-size: 14px;
  line-height: 1.4;
}

/* 材料题附件样式调整 */
.ep-material {
  margin: 10px 0;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 6px;
  background-color: #f9f9f9;
}

.ep-material-preview {
  max-width: 100%;
  margin-bottom: 10px;
}

.ep-material-image {
  max-width: 100%;
  max-height: 300px;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.ep-material-info {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.ep-material-name {
  font-size: 13px;
  color: #666;
  margin: 0;
}

.ep-download-btn {
  font-size: 12px;
  padding: 4px 8px;
  background-color: #f0f0f0;
  color: #555;
  border-radius: 4px;
  text-decoration: none;
  transition: all 0.2s ease;
}

.ep-download-btn:hover {
  background-color: #e0e0e0;
  color: #333;
}

/* 底部按钮调整 */
.ep-footer {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 30px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

.ep-submit-btn {
  padding: 8px 25px;
  background-color: #f8b62d;
  color: white;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 3px 8px rgba(248, 182, 45, 0.3);
}

.ep-submit-btn:hover {
  background-color: #e6a012;
  /* transform: translateY(-2px); */
  box-shadow: 0 4px 12px rgba(248, 182, 45, 0.4);
}

/* 加载和错误状态调整 */
.ep-loading,
.ep-error {
  text-align: center;
  padding: 30px;
  font-size: 14px;
}

.ep-retry-btn {
  margin-top: 10px;
  padding: 6px 15px;
  background-color: #f8b62d;
  color: white;
  border: none;
  border-radius: 16px;
  cursor: pointer;
  font-size: 13px;
}

/* 填空题答案样式 */
.ep-blank-answer .ep-answer-content {
  margin-bottom: 5px;
}

/* 删除不需要的样式 */
.option-marker,
.correct-marker {
  display: none;
}


/* 选项标签样式优化 */
.ep-option-label {
  display: flex;
  align-items: center;
  /* 修改为center以实现垂直居中 */
}



/* 选项项目样式优化 - 调整内边距使垂直居中更明显 */
.ep-option {
  padding: 12px 15px;
  /* 增加垂直内边距 */
  border-radius: 8px;
  background-color: #f8f9fa;
  border: 1px solid #eee;
  transition: all 0.2s ease;
  display: flex;
  /* 添加flex布局 */
  align-items: stretch;
  /* 子元素拉伸以填充容器高度 */
}

.ep-option-correct {
  background-color: rgba(76, 175, 80, 0.1);
  border: 1px solid rgba(76, 175, 80, 0.3);
  position: relative;
  /* border-left: 3px solid #4CAF50; */
}

.ep-option-correct:hover {
  background-color: rgba(76, 175, 80, 0.15);
}



/* 添加正确选项的特殊标记 */
.ep-option-correct::after {
  display: flex;
  align-items: center;
  content: "✓";
  position: absolute;
  right: 15px;
  color: #4CAF50;
  font-weight: bold;
  font-size: 16px;
  height: calc(100% - 24px);
}

.paper-content {
  width: 100%;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #d8d8d8;
  border-radius: 4px;
  transition: all 0.3s ease;
}

::-webkit-scrollbar-thumb:hover {
  background: #b0b0b0;
}

@media (max-width: 1800px) {
  .content-div {
    padding-left: 10px;
    padding-right: 10px;
    /* max-width: 1600px; */
    /* min-width: 0px; */
  }

}

@media (max-width: 1200px) {
  .content-div {
    max-width: 800px;
    min-width: 800px;
  }
}

@media (max-width: 768px) {
  .content-div {
    width: 100%;
    min-width: 0px;
  }

  .ep-question {
    margin-left: 10px;
    margin-right: 10px;
  }

}
</style>
